module.exports = __webpack_public_path__ + "static/media/arched.59cafb29.png";